import { render, staticRenderFns } from "./PureSelect.vue?vue&type=template&id=07f2a65d&scoped=true&"
import script from "./PureSelect.vue?vue&type=script&lang=js&"
export * from "./PureSelect.vue?vue&type=script&lang=js&"
import style0 from "./PureSelect.vue?vue&type=style&index=0&id=07f2a65d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f2a65d",
  null
  
)

export default component.exports